import React, { useRef } from 'react';
import { KModal } from '@/ui-library/components/molecules/KModal/KModal';
import { KText } from '@/ui-library/components/text';
import { useSelector } from 'react-redux';
import { getAtsJobCreate } from '@/store/atsJobCreate';
import { FormBuilder } from '@/components/formBuilder';

interface RemoveRequisitionConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (stageId?: number | string) => void;
  isLoading?: boolean;
  title?: string;
  description?: string;
  ctaLabel?: string;
  applicationData?: {
    job_stage_id: string;
  };
  showStageSelection?: boolean;
}

export const RemoveRequisitionConfirmModal: React.FC<
  RemoveRequisitionConfirmModalProps
> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  title = 'Remove associated requisition?',
  description = 'Moving this candidate out of the hired stages will remove their associated requisition. The requisition will be reopened.',
  ctaLabel = 'Confirm',
  applicationData,
  showStageSelection = false,
}) => {
  const formRef = useRef(null);
  const { getInterviewPlan = {} } = useSelector(getAtsJobCreate);
  const { data: interviewPlan = [], isLoading: isIntPlnLoading } =
    getInterviewPlan;

  const deleteWithStageFormFields = [
    {
      name: 'stage',
      type: 'select',
      isRequired: true,
      label: 'Select stage',
      isAppendToBody: true,
      placeholder: 'Select stage',
      options: interviewPlan?.filter(
        (currIP) => currIP?.id !== applicationData?.job_stage_id
      ),
      valueKey: 'id',
      labelKey: 'name',
      isLoading: isIntPlnLoading,
    },
  ];

  return (
    <KModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="md"
      ctaLabel={ctaLabel}
      ctaAction={() => {
        if (showStageSelection) {
          formRef.current?.submitForm();
        } else {
          onConfirm(undefined);
        }
      }}
      isCtaLoading={isLoading}
      closeOnOverlayClick={!isLoading}
      closeOnEsc={!isLoading}
      enableCancelBtn={true}
      ctaButtonProps={{
        variant: 'primary',
      }}
    >
      <KText size="sm-regular" color="secondary-700">
        {description}
      </KText>
      {showStageSelection && (
        <FormBuilder
          config={deleteWithStageFormFields}
          formRef={formRef}
          initialValues={{}}
          onSubmit={(values) => {
            if (values?.stage) {
              onConfirm(values.stage);
            }
          }}
        />
      )}
    </KModal>
  );
};
